import React from "react";
import { useTheme } from "../../../../theme/ThemeProvider";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

export default function CustomChart(props) {
  const { lineChartData, unit, batMSBData, contractCap } = props;
  const { theme } = useTheme();
  const totalNumData = lineChartData.length;
  let xAxisTime;
  if (totalNumData < 6) {
    xAxisTime = lineChartData.map(item => item.jsTime);
  } else {
    xAxisTime = [
      lineChartData[0]["jsTime"],
      lineChartData[Math.ceil(totalNumData / 6)]["jsTime"],
      lineChartData[Math.ceil((2 * totalNumData) / 6)]["jsTime"],
      lineChartData[Math.ceil((3 * totalNumData) / 6)]["jsTime"],
      lineChartData[Math.ceil((4 * totalNumData) / 6)]["jsTime"],
      lineChartData[Math.ceil((5 * totalNumData) / 6)]["jsTime"],
      lineChartData[totalNumData - 1]["jsTime"],
    ];
  }

  // Extract batMSB value from the data
  const batMSBValues = batMSBData.map(item => {
    const str = item.thing_name.split("_");
    return {
      "msb": item.batMSB.toLowerCase(),
      "bat": str.length > 1 ? str[1] : ""
    };
  });

  const lineKeys = Object.keys(lineChartData[0]).filter(key => key !== "jsTime");
  const brightColors = ["#FF5733", "#5733FF", "#2bb667", "#dad700", "#33A1FF"];

  const getColorHighlight = (key, index) => {
    if (key === "total" || lineKeys.length === 1) {
      return theme === "dark" ? "#ffffff" : "#000000";
    } else {
      const batMSBValue = batMSBValues.find(item => item.msb === key)?.msb;
      const n = batMSBValues.findIndex(item => item.msb === key);
      if (batMSBValue) {
        const colorIndex = n % brightColors.length;
        return brightColors[colorIndex];
      }
    }
    return "#bbbbbb";
  }

  const getLegendName = (key) => {
    const batMSBValue = batMSBValues.find(item => item.msb === key)?.msb;
    const batValue = batMSBValues.find(item => item.msb === key)?.bat;
    if (batMSBValue) {
      return `${key} (${batValue})`;
    }
    return key;
  }

  const axisColor = theme === "dark" ? "#e9ecef" : "#212529";
  const gridColor = theme === "dark" ? "#495057" : "#dee2e6";

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        width={500}
        height={300}
        data={lineChartData}
        margin={{
          top: 5,
          right: 55,
          left: 45,
          bottom: 5,
        }}
      >
        {contractCap && (
          <ReferenceLine
            y={contractCap * 1000}
            stroke="rgb(255, 0, 200)"
          />
        )}
        <CartesianGrid strokeDasharray="3 3" stroke={gridColor} />
        <XAxis dataKey="jsTime" ticks={xAxisTime} tick={{ fill: axisColor }} stroke={gridColor} />
        <YAxis unit={unit} tick={{ fill: axisColor }} stroke={gridColor} />

        <Tooltip />
        <Legend formatter={getLegendName} />
        {lineKeys.map((key, index) => (
          <Line
            key={index}
            type="monotone"
            dataKey={key}
            stroke={getColorHighlight(key, index)}
            dot={false}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
}
